module.exports = __webpack_public_path__ + "img/2.08afe2c4.png";